import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FcwidgetService } from 'src/app/core/util/fcwidget.service';
import { Subject, takeUntil } from 'rxjs';

/**
 * Single fcwidget component: shows status while the Freshchat widget is loading/initializing.
 * Widget initialization and open (including openWithUserContext) are handled by FcwidgetService.
 * Place once in the layout (e.g. basic and passport) so status appears when the widget is
 * triggered from any entry point (Need help, Contact Us, Qbot AI Support, etc.).
 */
@Component({
  selector: 'app-fcwidget',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './fcwidget.component.html',
  styleUrls: ['./fcwidget.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FcwidgetComponent implements OnDestroy {
  private readonly fc = inject(FcwidgetService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroy$ = new Subject<void>();

  loading = false;

  constructor() {
    this.fc.loading$.pipe(takeUntil(this.destroy$)).subscribe((loading) => {
      this.loading = loading;
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
